
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_2_1_","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 32 32","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M13.3 5.5v10.2H5.5V5.5h7.8M14.8 4H5.5C4.7 4 4 4.7 4 5.5v11.7h10.8V4zM13.3 21.1v5.4H5.5v-5.4h7.8m1.5-1.5H4v6.9c0 .8.7 1.5 1.5 1.5h9.3v-8.4zM26.5 5.5v5.4h-7.8V5.5h7.8m0-1.5h-9.3v8.4H28V5.5c0-.8-.7-1.5-1.5-1.5zM26.5 16.3v10.2h-7.8V16.3h7.8m1.5-1.5H17.2V28h9.3c.8 0 1.5-.7 1.5-1.5V14.8z"}})])
          )
        }
      }
    